import React, {
  useLayoutEffect,
  useEffect,
  useRef,
  useState,
  useContext
} from 'react';
import useSectionStyles from './styles';
import OptionList from './optionList';
import Button from '../button/index';
import Icon from '../../icon';
import { useTheme } from '../../theme/theming';
import { useLinkBuilder } from '../../hooks/useLinkBuilder';
import phoneIos from '../../assets/images/phoneIos.svg';
import phoneAndroid from '../../assets/images/phoneAndroid.svg';
import NextImageRenderer from '../nextImageRenderer';
import PageContext from '../../contexts/pageContext';
import { DEFAULT_HEADER_IMAGE_LP } from '../../utils/constants';
import { getAppDownloadLink } from '../../utils';
import moment from 'moment';
import Countdown from 'react-countdown';
import timer from '../../assets/images/timer.svg';

export default function MobileHeader({
  header,
  navData,
  isTutorWebsite,
  isLandingPage = false,
  onDownloadAppTriggered,
  extraProps
}) {
  const { isCustomWebsite, countryCode, isEdit } = useContext(PageContext);
  const { isFixed = true } = header;
  const logoUrl = useLinkBuilder({ isLink: true, link: '/' });
  const theme = useTheme();
  const classes = useSectionStyles({ isFixed, isCustomWebsite });
  const [sideMenu, openSideMenu] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const navEl = useRef(null);
  useLayoutEffect(() => {
    const body = navEl?.current?.ownerDocument?.body;
    if (body) {
      if (sideMenu) {
        // body?.setAttribute('style', 'overflow: hidden;');
        body.style.overflow = 'hidden';
      } else {
        // body?.removeAttribute('style');
        body.style.overflow = '';
      }
      if (header?.effectivePrice) {
        body.style.marginBottom = '130px';
      } else {
        body.style.marginBottom = '';
      }
    }
  }, [sideMenu, header?.effectivePrice]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 220) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    if (header?.effectivePrice) {
      const body = navEl?.current?.ownerDocument?.body;
      if (body) {
        body.style.marginBottom = '130px';
      }

      window.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (header?.effectivePrice) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  let iosUrl = null;
  let androidUrl = null;
  let downloadLink = null;

  const downloadAppText = countryCode === 'KR' ? '앱다운로드' : 'Download App';
  const apkURL = header?.apkURL;
  const isAndroidDelisted = header?.isAndroidDelisted;
  const iosDownloadLink = header?.iosDownloadLink || header?.iosUrl;
  const androidDownloadLink = header?.androidDownloadLink;

  // console.log(header, 'sakshat header mobile');

  const getDiscount = (price, discount) => {
    return ((discount / price) * 100).toFixed(2);
  };

  const renderer = ({ days, hours, minutes, seconds }) => {
    if (days === 0 && hours < 24) {
      return (
        <div className={classes.offerBottom}>
          <div>Offer ends in</div>
          <div style={{ display: 'flex', gap: '5px' }}>
            <img src={timer} alt="" />{' '}
            <div>
              {hours} <span className={classes.smallText}>hrs</span> : {minutes}{' '}
              <span className={classes.smallText}>Mins</span> : {seconds}{' '}
              <span className={classes.smallText}>Secs</span>
            </div>
          </div>
        </div>
      );
    } else {
      let given = moment(header.endDate);
      let current = moment().startOf('day');
      return (
        <div className={classes.offerBottom}>
          <div>This offer is only valid for</div>
          <div style={{ display: 'flex', gap: '5px' }}>
            <img src={timer} alt="" />{' '}
            <div>
              {Math.floor(moment.duration(given.diff(current)).asDays())}
              <span className={classes.smallText}>&nbsp;&nbsp;Days</span>
            </div>
          </div>
        </div>
      );
    }
  };

  const OfferDetailsJSX = () => {
    console.log('offer details jsx', header);
    const body = navEl?.current?.ownerDocument?.body;
    if (body) {
      body.style.marginBottom = '130px';
    }
    let conversions = extraProps?.conversions || 0;
    const currentTimestamp = new Date().getTime();
    if (
      header?.isOfferActive &&
      header?.endDate &&
      header?.endDate &&
      header?.endDate > currentTimestamp &&
      (header?.offerPriceValidFor
        ? header.offerPriceValidFor - conversions > 0
        : true)
    ) {
      return (
        <div className={classes.BottomSheetOfferContainer}>
          {' '}
          <Countdown renderer={renderer} date={header?.endDate} />
        </div>
      );
    }
    return null;
  };

  const BottomSheetJSX = () => {
    if (!header?.effectivePrice || (!isVisible && !isEdit)) {
      return null;
    }
    return (
      <>
        <div className={classes.BottomSheetContainer}>
          {OfferDetailsJSX()}
          <div className={classes.BottomSheetPriceContainer}>
            <div className={classes.BottomSheetPrice}>
              <div>
                {header?.effectivePrice ? (
                  <div style={{ textAlign: 'start' }}>
                    <span className={classes.offerPrice}>
                      ₹ {header?.effectivePrice}
                    </span>{' '}
                  </div>
                ) : null}
                {header?.price &&
                header?.discount &&
                header?.effectivePrice &&
                header?.price !== header?.effectivePrice ? (
                  <>
                    <span className={classes.originalPrice}>
                      ₹ {header?.price}
                    </span>{' '}
                    <span className={classes.offerDiscount}>
                      {`${getDiscount(header?.price, header?.discount)}%`}
                      &nbsp;OFF
                    </span>
                    &nbsp;&nbsp;
                  </>
                ) : null}
              </div>
            </div>
            <Button
              data={{
                // link: 'headerData?.loginCtaLink',
                // isLink: 1,
                value: 'BUY NOW'
                // isExternal: 1
              }}
              onClick={extraProps?.courseBuyNow}
              type={'primary'}
              size={'medium'}
              target={null}
              name="button"
              rel={null}
              // styling={isMobile ? { margin: '0 40px' } : {}}
            />
          </div>
        </div>
      </>
    );
  };

  if (isTutorWebsite) {
    if (isAndroidDelisted && apkURL) {
      downloadLink = (
        <Button
          data={{
            value: downloadAppText,
            isExternal: 1
          }}
          type={'primary'}
          size={'small'}
          target={'blank'}
          rel={null}
          onClick={() => {
            let url = getAppDownloadLink(apkURL, iosDownloadLink);
            window.open(url, '_blank');
            if (url === apkURL && typeof onDownloadAppTriggered == 'function') {
              onDownloadAppTriggered(header?.isAndroidDelisted, header?.apkURL);
            }
          }}
        />
      );
    } else if (androidDownloadLink?.length || iosDownloadLink?.length) {
      downloadLink = (
        <Button
          data={{
            link: getAppDownloadLink(androidDownloadLink, iosDownloadLink),
            isLink: 1,
            value: downloadAppText,
            isExternal: 1
          }}
          type={'primary'}
          size={'small'}
          target={'blank'}
          rel={null}
        />
      );
    } else {
      downloadLink = null;
    }
  } else {
    if (isAndroidDelisted && apkURL) {
      downloadLink = (
        <Button
          data={{
            value: downloadAppText,
            isExternal: 1
          }}
          type={'primary'}
          size={'small'}
          target={'blank'}
          rel={null}
          onClick={() => {
            let url = getAppDownloadLink(apkURL, iosDownloadLink);
            window.open(url, '_blank');
            if (url === apkURL && typeof onDownloadAppTriggered == 'function') {
              onDownloadAppTriggered(header?.isAndroidDelisted, header?.apkURL);
            }
          }}
        />
      );
    } else if (header?.appLink || header?.iosUrl) {
      console.log('inside custom website');
      downloadLink = (
        <Button
          data={{
            link: getAppDownloadLink(header?.appLink, header?.iosUrl),
            isLink: 1,
            value: downloadAppText,
            isExternal: 1
          }}
          type={'primary'}
          size={'small'}
          target={'blank'}
          rel={null}
        />
      );
    } else {
      downloadLink = null;
    }
  }

  return (
    <>
      <nav ref={navEl} className={classes.section}>
        {!(
          header?.websiteLogo === DEFAULT_HEADER_IMAGE_LP && isCustomWebsite
        ) ? (
          <div className={classes.headerSection}>
            <div className={classes.mobileHeader}>
              <div className={classes.mobileContent}>
                {!!navData?.length && (
                  <div
                    onClick={() => {
                      openSideMenu(true);
                    }}
                    className={classes.sideDrawerImg}
                  >
                    <Icon
                      name={'Menu'}
                      color={theme.palette.primary.main}
                      width={'24px'}
                    />
                  </div>
                )}

                {header?.websiteLogo ? (
                  <a
                    href={logoUrl}
                    className={classes.imageAnchorMobile}
                    style={{
                      pointerEvents: isLandingPage ? 'none' : 'auto',
                      cursor: isLandingPage ? 'not-allowed' : 'default'
                    }}
                  >
                    <div className={classes?.imageDivImageMobile}>
                      <NextImageRenderer
                        src={header?.websiteLogo}
                        className={classes.imageDivImageNext}
                        order={1}
                      />
                    </div>
                    {/* <img src={header?.websiteLogo} /> */}
                  </a>
                ) : null}
                {isTutorWebsite && header?.appName ? (
                  <p className={classes.mobileAppNameClass}>
                    {' '}
                    {header?.appName}
                  </p>
                ) : null}
              </div>
              {downloadLink}
            </div>

            {sideMenu ? (
              <div className={classes.mobileMenu}>
                <div
                  className={classes.backdrop}
                  onClick={() => {
                    openSideMenu(false);
                  }}
                />
                <div className={classes.menuContainer}>
                  <div className={classes.menuItem}>
                    <OptionList
                      optionsData={navData}
                      navDataCount={navData?.length}
                      headerData={header}
                      isMobile
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          <div
            style={{
              paddingTop: '30px'
            }}
          ></div>
        )}
      </nav>
      <BottomSheetJSX />
    </>
  );
}
